import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {FormControl, NgForm} from '@angular/forms';
import {AffiliateService} from '../affiliate.service';
import {Constants} from '../../../shared/utils/constants';
import {AppService} from '../../../app.service';
import {Permission} from '../../../models/permission.model';
import {Broadcaster} from '../../../app.broadcast';
import {TraderCampaign} from "../../../models/founder.model";

@Component({
  selector: 'fx-create-account',
  templateUrl: './create-account.component.html',
  styleUrls: ['./create-account.component.sass']
})
export class CreateAccountComponent implements OnInit {
  @ViewChild('formAcc') formAcc: NgForm;
  account: any = {};
  ib: any = {};
  listConfig = [];
  listCampaign = [];
  groupSetting = [];
  listAccountComplete =[];
  labelMT4Group = Constants.LABEL_MT4_GROUP;
  permission: Permission;
  showError = false;
  myControlCreate = new FormControl();
  constructor(
    private service: AffiliateService,
    public appService: AppService,
    public  broadcaster: Broadcaster,
  ) {
    this.permission = this.appService.getCurrentPermission(location.pathname);
  }

  ngOnInit(): void {
  }

  getListTraderCampaign(): void {
    if (this.account.ibEmail) {
      this.account.campaign = '';
      const params = {
        email: this.account.ibEmail,
      };
      this.listCampaign = [];
      this.service.getTraderCampaign(params)
        .subscribe(res => {
          if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
            this.listCampaign = res.data;
          }
      });
    }

  }

  onCreateUser(): void {
    if (this.formAcc.valid) {
      const body = {
        user_email: this.account.userEmail,
        ib_email: this.account.ibEmail,
        trader_campaign_id:this.account.campaign,
        group_config_id: this.account.groupConfig
     };
      this.service.createMT5Account(body)
       .subscribe(res => {
         if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
           this.appService.showSuccess('Create MT5 account success');
           this.formAcc.onReset();
         } else {
           this.appService.showError('Create MT5 account fail');
         }
       });
    }
  }

  changeReferLink(): void{
    if(this.account.campaign !== ''){
      this.getGroupByAffiliate();
    }
  }
  private getGroupByAffiliate(): void {
    let campaign: TraderCampaign = this.listCampaign.filter((item) => this.account.campaign == item.id)[0];
    this.groupSetting = campaign.groups;
  }
}
